import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Customer, State } from "../state/types";
import { upsertDraftSuccess } from "./animals";

export const customerSlice = createSlice({
  name: "customer",
  initialState: {} as State["customer"],
  reducers: {
    updateCustomer: (customer, action: PayloadAction<Partial<Customer>>) => {
      return {
        ...customer,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(upsertDraftSuccess, (state, action) => {
      state.clientId = action.payload.clientId;
    });
  },
});

// Action creators are generated for each case reducer function
export const { updateCustomer } = customerSlice.actions;

export const customerReducer = customerSlice.reducer;
